import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "../../../../styles/layouts/header/shoppingCart/shoppingCartHeaderIconComponent.scss";

const ShoppingCartHeaderIconComponent = () => {
  // Get the total products from the shopping cart state
  const totalProducts = useSelector((state) => state.shoppingCart.shoppingCartItems.length);

  return (
    <Link to="/shoppingCart" className="shppongCartIconContainer">
      <i className="fa fa-shopping-cart"></i>
      {totalProducts > 0 && <span className="cart-bubble">{totalProducts}</span>}
    </Link>
  );
};

export default ShoppingCartHeaderIconComponent;
